import React, { useEffect, useState } from "react";
import colors from "../../../../utils/helpers/helperDataset/colors.json";
import { getRandomArbitrary } from "../../../../utils/helpers/helperMethods/NumberGenerator";

interface Props {
  firstName: string;
  lastName: string;
  image: string;
}

const ProfilePictureController: React.FC<Props> = ({
  firstName,
  lastName,
  image,
}) => {
  const [color, setColor] = useState("");

  useEffect(() => {
    let searchedColor = colors[parseInt(String(getRandomArbitrary(0, 1300)))];
    setColor(searchedColor.hex);
  }, []);

  return (
    <div>
      {image ? (
        <img src={image} alt="profile" />
      ) : (
        <div className="manual-profile-pic" style={{ backgroundColor: color }}>
          {firstName.charAt(0)}
          {lastName.charAt(0)}
        </div>
      )}
    </div>
  );
};

export default ProfilePictureController;
